import React from 'react';

// Elegant minimalist spinner loader
function Loader({ label = 'Učitavanje...' }) {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <span className="loader-spinner mb-4" />
      <span className="text-gray-700 text-base font-medium tracking-wide" style={{fontFamily: 'Montserrat, sans-serif'}}>{label}</span>
      <style>{`
        .loader-spinner {
          display: inline-block;
          width: 48px;
          height: 48px;
          border: 3px solid #bfa46d33;
          border-top: 3px solid #bfa46d;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Loader;
